<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Master Data" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <!-- <form> -->
          <div class="row mb-5">
            <div class="col-md-6">
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <div class="row mt-2">
                <div class="col-md-12">
                  <button
                    type="submit"
                    @click="handleForm"
                    class="btn btn-primary btn-with-icon-left float-right text-uppercase ml-3"
                  >
                    <i class="material-symbols-outlined">check</i>
                    Simpan Jadwal Dokter
                  </button>
                  <!-- <router-link
                    class="btn btn-outline-danger btn-no-outline float-right"
                    to="/master/jadwal-dokter"
                    >Batalkan</router-link
                  > -->
                  <a
                    class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                    @click="() => goBack('/master/jadwal-dokter')"
                    >Batalkan
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
// import FormGroup from "@/components/FormGroup.vue";
import FormData from "form-data";
// import { HTTP } from "@/config.js";
let data = {
  title: "Jadwal Dokter Baru",
  backBtn: "/master/jadwal-dokter",
  actionBtn: [],
  breadcrumb: [
    { title: "Jadwal Dokter", link: "/master/jadwal-dokter" },
    { title: "Baru", active: true },
  ],
};

export default {
  name: "Jadwal DokterForm",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    // FormGroup
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      leftForm: [
        {
          colnum: 1,
          columns: [
            {
              name: "id_dokter",
              type: "select",
              label: "Pilih Dokter",
              options: [],
            },
          ],
        },
        {
          colnum: 3,
          columns: [
            {
              name: "hari",
              type: "select",
              label: "Pilih Hari",
              options: [
                { value: "Senin", label: "Senin" },
                { value: "Selasa", label: "Selasa" },
                { value: "Rabu", label: "Rabu" },
                { value: "Kamis", label: "Kamis" },
                { value: "Jumat", label: "Jumat" },
                { value: "Sabtu", label: "Sabtu" },
                { value: "Minggu", label: "Minggu" },
              ],
            },
            { name: "jam_mulai", type: "time", label: "Jam Mulai" },
            { name: "jam_selesai", type: "time", label: "Jam Selesai" },
          ],
        },
      ],
      formSet: {
        id_dokter: "",
        hari: "",
        jam_mulai: "",
        jam_selesai: "",
      },
    };
  },
  methods: {
    goBack(url) {
      if (window.history.length <= 1) {
        this.$router.push({ path: url });
      } else {
        this.$router.go(-1);
      }
    },
    handleForm: async function() {
      //console.log(this.formSet.no_rm);
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          formData.append(key, self.formSet[key]);
        });
        try {
          let result = await this.$store.state.HTTP.post(
            "dokter/jadwal/harian",
            formData
          );
          //console.log(result);
          if (result.status == "200") {
            this.$router.push(`/master/jadwal-dokter`);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
        }
      } else {
        //console.log("tidak valid");
      }
    },
    handleChange(e) {
      this.formSet[e.target.name] = e.target.value;
    },
    fetchDoctors: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "dokter?per_page=9999999999"
        );
        if (result.status == "200") {
          //console.log(result);
          let doctors = result.data.data.map((item) => {
            item.label = item.formatted_nama;
            item.value = item.id;
            return item;
          });
          this.leftForm[0].columns[0].options = doctors;
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      this.leftForm = this.leftForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }
          column.value = self.formSet[column.name];
          return column;
        });
        return row;
      });
      return valid;
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.fetchDoctors();
  },
};
</script>
